<template lang="pug">
  .component-vehicle-overview(v-if="vehicle")
    .action-bar
      .title
        h2 Vehicle Overview
    .vehicle.tabs-inner-content
      .row
        .columns
          vehicle(:item="vehicle", :type="'vehicle-card'", @update="loadVehicle")
          .info(v-if="vehicle.slot_id === null") Vehicle is not associated do a parking lot
            create-vehicle-slot(:item="vehicle", @update="loadVehicle")
        .columns
          vehicle-hardware(v-if="vehicle.hardware", :item="vehicle.hardware", :type="'hardware-card'", @update="loadVehicle")
          vehicle-hardware-reveal-create(v-else, :item="vehicle", @update="loadVehicle").text-center

          hr
          SearchVehicleAvailability(v-if="vehicle && vehicle.slot_id", :vehicle="vehicle", :selectable="false")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import Vehicle from 'components/backoffice/Vehicle.vue'
  import VehicleHardware from "components/backoffice/VehicleHardware";
  import VehicleHardwareRevealCreate from "../../structure/ui/actions/reveal/VehicleHardwareRevealCreate";
  import SearchVehicleAvailability from '../SearchVehicleAvailability'
  import CreateVehicleSlot from '../../structure/ui/actions/asset-management/CreateVehicleSlot'

  export default {
    name: "VehicleOverview",
    components: {
      CreateVehicleSlot,
      SearchVehicleAvailability,
      VehicleHardwareRevealCreate,
      VehicleHardware,
      Vehicle
    },
    data() {
      return {
        vehicle: null
      }
    },
    created() {
      this.loadVehicle()
    },
    methods: {
      loadVehicle() {
        KeplerBackofficeSdk.vehicles.select(this.$route.params.id).get((data) => {
          this.vehicle = data
        })
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .driver-profile
    margin: 10px
  .vehicle.tabs-inner-content
    padding: 1em 0 0
    &>.row
      margin: 0

</style>



// WEBPACK FOOTER //
// VehicleOverview.vue?31377fc2